import { FC, useState } from 'react';
import { taskProps, tenderDataProps } from '../../../pages/TenderViewPage/types';
import { useApproveTaskMutation } from '../../../api/tenders';
import ContactDetailsIcon from '../../../assets/ContactDetailsIcon.svg';
import pendingIcon from '../../../assets/panding-circle.svg';
import done from '../../../assets/Done, Check.svg';
import { ContactDetailsModal } from './ContactDetailsModal';
import calendar from '../../../assets/calendar-chedule.svg';
import clock from '../../../assets/clock.svg';
import moment from 'moment';
import Money from '../../../assets/Money, Coins.svg';
import edit from '../../../assets/editAdminIcon.svg';
import editIcon from '../../../assets/editAdminIcon.svg';

interface DefineContactDetailsProps {
    data: tenderDataProps;
    role: string | null;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DefineContactDetails: FC<DefineContactDetailsProps> = ({ data, role, setTrigger }) => {
    const [openModal, setOpenModal] = useState(false);

    const [approveTask, { isLoading }] = useApproveTaskMutation();

    const approveTaskFunc = async (taskId: number) => {
        try {
            const formData = {
                tenderId: data?.id,
                taskId: taskId
            };
            await approveTask(formData).unwrap();
            await setTrigger((prev: boolean) => !prev);
        } catch {}
    };

    return (
        <>
            {data?.phase_tasks.length > 0 &&
                data?.phase_tasks.map((elem: taskProps) => {
                    if (elem.action === 'define_contract_details') {
                        if (role !== 'school_user') {
                            if (elem.status === 'need_approve_tr') {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete green
                            `}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={ContactDetailsIcon} />
                                                {elem?.name}
                                            </div>
                                            <div className="task-complete__title-row">
                                                {!elem.approved && role !== 'super_admin' && (
                                                    <div
                                                        className="task-complete__decline"
                                                        onClick={() => setOpenModal(true)}
                                                    >
                                                        <img
                                                            src={edit}
                                                            style={{ margin: '0px 2px -5px 0', width: '21px' }}
                                                        />{' '}
                                                        Edit
                                                    </div>
                                                )}

                                                {elem.approved ? (
                                                    <div className="task__btn-wrap">
                                                        <span className="task__approved-active">
                                                            <img src={done} />
                                                            Approved
                                                        </span>
                                                    </div>
                                                ) : (
                                                    role !== 'super_admin' && (
                                                        <div
                                                            className={`task-complete__approved`}
                                                            onClick={() => {
                                                                if (isLoading) return;
                                                                approveTaskFunc(elem.id);
                                                            }}
                                                        >
                                                            Approve
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>

                                        <div
                                            className="task-complete__info-wrap contact-details row"
                                            style={{ gap: '16px' }}
                                        >
                                            <div className="task-complete__element">
                                                Contract Term
                                                <div>
                                                    <img src={clock} />
                                                    {elem.contract_duration?.value}
                                                </div>
                                            </div>
                                            <div className="task-complete__element">
                                                Service Start Date
                                                <div>
                                                    <img src={calendar} />
                                                    {moment(elem.service_start_date).format('YYYY-MM-DD')}
                                                </div>
                                            </div>
                                            <div className="task-complete__element">
                                                Estimated Annual Contract Value
                                                <div>
                                                    <img src={Money} />
                                                    {elem.contract_value?.value}
                                                </div>
                                            </div>
                                            <div className="task-complete__element">
                                                Total Estimated Contract Value
                                                <div>
                                                    <img src={Money} />
                                                    {elem.total_contract_value
                                                        .toString()
                                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        }
                        if (role === 'school_user') {
                            if (elem.status === 'pending_su') {
                                return (
                                    <div key={elem.id} className={`tasks__task task `}>
                                        <div className="task__title">
                                            <div className="task-complete__title-row">
                                                <img src={ContactDetailsIcon} />
                                                {elem?.name}
                                            </div>
                                            <div className="task-complete__title-row"></div>
                                        </div>
                                        <div className="task-complete__btn" onClick={() => setOpenModal(true)}>
                                            Specify
                                        </div>
                                    </div>
                                );
                            }
                            if (elem.status === 'completed' || elem.status === 'need_approve_tr') {
                                return (
                                    <div
                                        key={elem.id}
                                        className={`tasks__task-complete task-complete ${
                                            elem.status === 'completed' ? 'green' : ''
                                        }
                            `}
                                    >
                                        <div className="task-complete__title">
                                            <div className="task-complete__title-row">
                                                <img src={ContactDetailsIcon} />
                                                {elem?.name}
                                            </div>
                                            {elem.status === 'completed' ? (
                                                <div className="task-complete__title-row">
                                                    <div className="task-complete__approved-active">
                                                        <img src={done} />
                                                        Completed
                                                    </div>
                                                </div>
                                            ) : elem.status === 'need_approve_tr' ? (
                                                <div className="task__pending" key={elem.id}>
                                                    <img src={pendingIcon} />
                                                    Pending
                                                </div>
                                            ) : (
                                                <></>
                                            )}
                                        </div>

                                        <div
                                            className="task-complete__info-wrap contact-details row"
                                            style={{ gap: '16px' }}
                                        >
                                            <div className="task-complete__element">
                                                Contract Term
                                                <div>
                                                    <img src={clock} />
                                                    {elem.contract_duration?.value}
                                                </div>
                                            </div>
                                            <div className="task-complete__element">
                                                Service Start Date
                                                <div>
                                                    <img src={calendar} />
                                                    {moment(elem.service_start_date).format('YYYY-MM-DD')}
                                                </div>
                                            </div>
                                            <div className="task-complete__element">
                                                Estimated Annual Contract Value
                                                <div>
                                                    <img src={Money} />
                                                    {elem.contract_value?.value}
                                                </div>
                                            </div>
                                            <div className="task-complete__element">
                                                Total Estimated Contract Value
                                                <div>
                                                    <img src={Money} />
                                                    {elem.total_contract_value
                                                        .toString()
                                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                </div>
                                            </div>
                                            {elem.status === 'completed' && (
                                                <img
                                                    src={editIcon}
                                                    className="task-complete__edit"
                                                    onClick={() => setOpenModal(true)}
                                                />
                                            )}
                                        </div>
                                    </div>
                                );
                            }
                        }
                    }
                    if (elem.action === 'design_contract_details') {
                        return (
                            <div
                                key={elem.id}
                                className={`tasks__task-complete task-complete
                            `}
                            >
                                <div className="task-complete__title">
                                    <div className="task-complete__title-row">
                                        <img src={ContactDetailsIcon} />
                                        {elem?.name}
                                    </div>
                                </div>

                                <div className="task-complete__info-wrap row" style={{ gap: '16px' }}>
                                    <div className="task-complete__element">
                                        Contract Term
                                        <div>
                                            <img src={clock} />
                                            {elem.contract_duration?.value}
                                        </div>
                                    </div>
                                    <div className="task-complete__element">
                                        Service Start Date
                                        <div>
                                            <img src={calendar} />
                                            {moment(elem.service_start_date).format('YYYY-MM-DD')}
                                        </div>
                                    </div>
                                    <div className="task-complete__element">
                                        Estimated Annual Contract Value
                                        <div>
                                            <img src={Money} />
                                            {elem.contract_value?.value}
                                        </div>
                                    </div>
                                    <div className="task-complete__element">
                                        Total Estimated Contract Value
                                        <div>
                                            <img src={Money} />
                                            {elem.total_contract_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }
                })}

            {openModal && (
                <ContactDetailsModal
                    openModal={openModal}
                    setOpenModal={setOpenModal}
                    tenderData={data}
                    setTrigger={setTrigger}
                />
            )}
        </>
    );
};
